import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { MarketGroup } from '../../models/marketGroup';
import { Observable } from 'rxjs';

export class MarketGroupDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.MARKETGROUPS, apiHelper);
  }

  getForBrand(_id: string): Observable<MarketGroup[]> {
    let url = this.apiHelper.getServiceName() + this.getResource() + `/byBrand/${_id}`;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }

  getById(_id: string): Observable<MarketGroup> {
    let url = this.apiHelper.getServiceName() + this.getResource() + `/${_id}`;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }
}

